import { useEffect, useRef } from 'react';
import { IconButton } from './Button';

/** Thông báo ngắn ở đáy màn hình (role status), tự ẩn sau `timeout` ms kể từ khi nội dung đổi. */
export function Toast({ message, onDismiss, timeout = 4200 }: { message: string; onDismiss: () => void; timeout?: number }) {
  const dismiss = useRef(onDismiss);
  dismiss.current = onDismiss;
  useEffect(() => {
    const t = setTimeout(() => dismiss.current(), timeout);
    return () => clearTimeout(t);
  }, [message, timeout]);
  return (
    <div className="ws-toast" role="status" data-testid="toast">
      <span>{message}</span>
      <IconButton label="Đóng thông báo" icon="close" size={16} onClick={onDismiss} />
    </div>
  );
}
